import { render } from "./TelaValidacao.vue?vue&type=template&id=a95ab72a&scoped=true"
import script from "./TelaValidacao.vue?vue&type=script&lang=js"
export * from "./TelaValidacao.vue?vue&type=script&lang=js"

import "./TelaValidacao.vue?vue&type=style&index=0&id=a95ab72a&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a95ab72a"]])

export default __exports__